export default "__VITE_ASSET__CD37I95u__"